<template>
    <div>
        <el-row>
            <el-col :span="12">
                <el-select v-model="catalogId" placeholder="Selección de Catálogo" filterable
                           @change="getCatalog(catalogId,1)">
                    <el-option
                        v-for="item in catalogs"
                        :key="item.id"
                        :label="item.name"
                        :value="item.id">
                    </el-option>
                </el-select>
            </el-col>
            <el-col align="end" :span="12">
                <el-button
                    type="danger"
                    icon="el-icon-arrow-left"
                    @click="$router.push('/administracion')">
                    Regresar
                </el-button>
            </el-col>
        </el-row>
        <br>
        <span v-if="showGeneric">
           <el-alert
               v-if="catalogId == 14"
               title="Este catálogo muestra a los usuarios activos como Delegado Fiduciario, la gestión de estos usuarios le corresponde al administrador del sistema"
               type="info"
               effect="dark">
           </el-alert>
           <div v-if="catalogId && showGeneric === true" align="right">
                <el-button
                    v-if="catalogId != 14"
                    type="success"
                    icon="fas fa-plus"
                    @click="showDialog()">
                    Agregar {{label}}
                </el-button>
                <el-col :span="6">
                    <el-input
                        v-my-only-alphanumeric="{maxChars: 500}"
                        v-if="catalogId != 14"
                        v-model="search"
                        clearable
                        placeholder="Buscar"
                        @clear="handleCurrentChange(currentPage,catalogId)"
                        @keyup.enter.native="handleCurrentChange(currentPage,catalogId)">
                        <el-button slot="append" :icon="icon"
                                   @click="handleCurrentChange(currentPage,catalogId)"></el-button>
                    </el-input>
                </el-col>
            </div>
            <br>
            <!--Generic Table 450 -->
            <el-table :data="dynamicCats"
                      v-if="catalogId === 2"
                      v-loading="loading"
                      element-loading-text=""
                      element-loading-spinner="el-icon-loading"
                      @cell-dblclick="customNotary"
                      border
                      stripe
                      height="350"
                      style="width: 100%">
                <el-table-column type="index" label="#"/>
                <el-table-column prop="name" sortable :label="label">
                        <template slot-scope="scope">
                            <el-input v-model="scope.row.name"
                                      v-my-only-alphanumeric="{maxChars: 500}"
                                      @keyup.enter="scope.row.editable = false"
                                      v-if="scope.row.editable == true"
                                      :disabled="scope.row.isActive == 0 || scope.row.isActive == false"/>
                            <el-tooltip class="item" effect="dark"
                                        style="z-index: 9999"
                                        v-if="scope.row.editable == false"
                                        content="Doble clic para editar"
                                        placement="top-end">
                                    <label
                                        @dblclick="scope.row.editable = true">{{scope.row.name}}</label>
                            </el-tooltip>
                        </template>

                </el-table-column>
                <el-table-column prop="cat_state_id" sortable label="Estado">
                    <template slot-scope="scope">
                       <el-select v-model="scope.row.cat_state_id"
                                  v-if="scope.row.editable == true"
                                  @change="scope.row.cat_municipality_id = null; getMunicipalities(scope.row.cat_state_id)"
                                  style="width: 100%"
                                  placeholder="Seleccione" filterable>
                                <el-option
                                    v-for="item in states"
                                    :key="item.id"
                                    :label="item.name"
                                    :value="item.id">
                                </el-option>
                        </el-select>
                         <el-tooltip class="item" effect="dark"
                                     style="z-index: 9999"
                                     v-if="scope.row.editable == false"
                                     content="Doble clic para editar"
                                     placement="top-end">
                                    <label
                                        @dblclick="customNotary(scope.row, scope.$index)">{{scope.row.state && scope.row.state.name ?
                                        scope.row.state.name : ''}}</label>
                            </el-tooltip>
                    </template>
                </el-table-column>
                <el-table-column prop="cat_municipality_id" sortable label="Municipio">
                    <template slot-scope="scope">
                       <el-select v-model="scope.row.cat_municipality_id"
                                  v-if="scope.row.editable == true"
                                  v-loading="loading"
                                  style="width: 100%"
                                  placeholder="Seleccione" filterable>
                                <el-option
                                    v-for="item in municipalities"
                                    :key="item.id"
                                    :label="item.name"
                                    :value="item.id">
                                </el-option>
                        </el-select>
                         <el-tooltip class="item" effect="dark"
                                     style="z-index: 9999"
                                     v-if="scope.row.editable == false"
                                     content="Doble clic para editar"
                                     placement="top-end">
                                    <label
                                        @dblclick="customNotary(scope.row, scope.$index)">{{scope.row.municipality && scope.row.municipality.name ?
                                        scope.row.municipality.name : ''}}</label>
                            </el-tooltip>
                    </template>
                </el-table-column>
                <el-table-column v-if="catalogId != 14" align="center" prop="isActive" label="Acciones de Edición"
                                 width="300">
                    <template slot-scope="scope">
                        <cats-actions :alias_this="alias_this" :method-reload="getCatalog"
                                      :cat="scope.row" :catId="catalogId"
                                      :label="label"></cats-actions>
                    </template>
                </el-table-column>

            </el-table>

            <el-table :data="dynamicCats"
                      v-if="catalogId != 2"
                      v-loading="loading"
                      element-loading-text=""
                      element-loading-spinner="el-icon-loading"
                      @cell-dblclick="changeEditable"
                      border
                      stripe
                      height="350"
                      style="width: 100%">
                <el-tooltip>

                </el-tooltip>
                <el-table-column prop="name" sortable :label="label" v-if="catalogId != 14">
                        <template slot-scope="scope">
                            <el-input v-model="scope.row.name"
                                      v-my-only-alphanumeric="{maxChars: 500}"
                                      @keyup.enter="scope.row.editable = false"
                                      v-if="scope.row.editable == true"
                                      :disabled="scope.row.isActive == 0 || scope.row.isActive == false"/>
                            <el-tooltip class="item" effect="dark"
                                        style="z-index: 9999"
                                        v-if="scope.row.editable == false"
                                        content="Doble clic para editar"
                                        placement="top-end">
                                    <label
                                        @dblclick="scope.row.editable = true">{{scope.row.name}}</label>
                            </el-tooltip>
                        </template>

                </el-table-column>
                <el-table-column prop="name" sortable :label="label" v-if="catalogId == 14">
                        <template slot-scope="scope" v-if="catalogId == 14">
                           <label>{{scope.row.full_name}} <br>
                               <span style="font-weight: bold !important;">
                                   {{scope.row.bank && scope.row.bank.name ?  ' BANCO: ' + scope.row.bank.name : ''}}
                               </span>
                           </label>
                        </template>
                        <template slot-scope="scope" v-if="catalogId == 14">
                           <label>{{scope.row.full_name}} <br>
                               <span style="font-weight: bold !important;">
                                   {{scope.row.bank && scope.row.bank.name ?  ' BANCO: ' + scope.row.bank.name : ''}}
                               </span>
                           </label>
                        </template>
                </el-table-column>
                <el-table-column prop="countryName" label="País" sortable v-if="catalogId == 6">
                    <template slot-scope="scope" @dblclick="scope.row.editable = true">
                        <el-input v-model="scope.row.countryName"
                                  v-my-only-alphanumeric="{maxChars: 500}"
                                  v-on:blur="scope.row.editable = false"
                                  @keyup.enter="scope.row.editable = false"
                                  v-if="scope.row.editable == true"
                                  style="width: 100%"
                                  :max="total"
                                  :disabled="scope.row.isActive == 0 || scope.row.isActive == false"/>
                        <el-tooltip class="item" effect="dark"
                                    v-if="scope.row.editable == false"
                                    content="Doble clic para editar"
                                    placement="top-end">
                            <label>{{scope.row.countryName}}</label>
                        </el-tooltip>
                    </template>
                </el-table-column>
                <el-table-column prop="isDiplomatic" label="Diplomática" sortable v-if="catalogId == 6">
                    <template slot-scope="scope" @dblclick="scope.row.editable = true">
                        <el-switch
                            v-if="scope.row.editable == true"
                            v-on:blur="scope.row.editable = false"
                            :disabled="scope.row.isActive == 0 || scope.row.isActive == false"
                            v-model="scope.row.isDiplomatic"
                            active-text="Sí"
                            inactive-color="#13322B"
                            active-color="#9d2438"
                            inactive-text="No">
                        </el-switch>
                        <el-tooltip class="item" effect="dark"
                                    v-if="scope.row.editable == false"
                                    content="Doble clic para editar"
                                    placement="top-end">
                            <label>{{scope.row.isDiplomatic ? 'Sí' : 'No'}}</label>
                        </el-tooltip>
                    </template>
                </el-table-column>
                <el-table-column prop="isDiplomatic" label="Requerido para extranjeros" sortable v-if="catalogId == 19">
                    <template slot-scope="scope" @dblclick="scope.row.editable = true">
                        <el-switch
                            v-if="scope.row.editable == true"
                            v-on:blur="scope.row.editable = false"
                            :disabled="scope.row.isActive == 0 || scope.row.isActive == false"
                            v-model="scope.row.isForeign"
                            active-text="Sí"
                            inactive-color="#13322B"
                            active-color="#9d2438"
                            inactive-text="No">
                        </el-switch>
                        <el-tooltip class="item" effect="dark"
                                    v-if="scope.row.editable == false"
                                    content="Doble clic para editar"
                                    placement="top-end">
                            <label>{{scope.row.isForeign ? 'Sí' : 'No'}}</label>
                        </el-tooltip>
                    </template>
                </el-table-column>
                <el-table-column v-if="catalogId != 14" align="center" prop="isActive" label="Acciones de Edición"
                                 width="300">
                    <template slot-scope="scope">
                        <cats-actions :alias_this="alias_this" :method-reload="getCatalog"
                                      :cat="scope.row" :catId="catalogId"
                                      :label="label"></cats-actions>
                    </template>
                </el-table-column>
            </el-table>
            <br>
           <el-pagination
               v-if="catalogId != 14"
               @current-change="handleCurrentChange"
               :current-page="currentPage"
               layout="total, ->, prev, pager, next"
               :total="total">
           </el-pagination>
           <el-tooltip class="item" effect="dark" content="Cerrar o Administrar otro Catálogo" placement="top-end">
                <el-button
                    type="danger"
                    icon="fas fa-times-circle"
                    align="right"
                    class="buttonFixed"
                    @click="closeTable" round>
                </el-button>
            </el-tooltip>
       </span>

        <span v-if="type == 2">
            <span v-if="catalogId == 5">
                <div v-if="catalogId" align="right">
                    <el-button
                        type="success"
                        icon="fas fa-plus"
                        @click="showDialog()">
                        Agregar {{label}}
                    </el-button>
                    <el-col :span="6">
                        <el-input
                            v-my-only-alphanumeric
                            v-model="search"
                            clearable
                            placeholder="Buscar"
                            @clear="handleCurrentChange(currentPage,catalogId)"
                            @keyup.enter.native="handleCurrentChange(currentPage,catalogId)">
                            <el-button slot="append" :icon="icon"
                                       @click="handleCurrentChange(currentPage,catalogId)"></el-button>
                        </el-input>
                    </el-col>
                </div>
                <br>
                <el-table :data="dynamicCats"
                          v-loading="loading"
                          element-loading-text=""
                          element-loading-spinner="el-icon-loading"
                          @cell-dblclick="changeEditable"
                          border
                          stripe
                          height="450"
                          style="width: 100%">
                    <el-table-column prop="name" sortable
                                     min-width="250"
                                     :label="label">
                            <template slot-scope="scope">
                                <el-input v-my-only-alphanumeric
                                          v-model="scope.row.name"
                                          @keyup.enter="scope.row.editable = false"
                                          v-if="scope.row.editable == true"
                                          :disabled="scope.row.isActive == 0 || scope.row.isActive == false"/>
                                <el-tooltip class="item" effect="dark"
                                            v-if="scope.row.editable == false"
                                            content="Doble clic para editar"
                                            placement="top-end">
                                        <label
                                            @dblclick="scope.row.editable = true">{{scope.row.name}}</label>
                                </el-tooltip>
                            </template>
                    </el-table-column>
                    <el-table-column label="Tipo de Trámite" prop="category.name"/>
                    <el-table-column align="center" prop="isActive" label="Acciones de Edición" width="300">
                        <template slot-scope="scope">
                            <cats-actions :alias_this="alias_this" :method-reload="getCatalog"
                                          :cat="scope.row" :catId="catalogId"
                                          :label="label"></cats-actions>
                        </template>
                    </el-table-column>
                </el-table>
                <br>
                <el-pagination
                    @current-change="handleCurrentChange"
                    :page-size="perPage"
                    :current-page="currentPage"
                    layout="total, ->, prev, pager, next"
                    :total="total">
                </el-pagination>
                <el-tooltip class="item" effect="dark" content="Cerrar o Administrar otro Catálogo"
                            placement="top-end">
                    <el-button
                        type="danger"
                        icon="fas fa-times-circle"
                        align="right"
                        class="buttonFixed"
                        @click="closeTable" round>
                    </el-button>
                </el-tooltip>
            </span>
        </span>

        <!--Related Catalogs-->


        <div class="tip" v-if="label == ''">
            <h5 align="center">Seleccione un catálogo de la lista para ser administrado. </h5>
        </div>

        <!--Add simple field-->
        <el-dialog :title="'Agregar '+ label"
                   :visible.sync="addNew"
                   :close-on-press-escape="false"
                   :close-on-click-modal="false">
            <el-form @submit.native.prevent ref="genericForm" :model="genericForm" label-width="120px"
                     label-position="top">
                <el-row :gutter="20">
                    <el-col :span="24">
                        <el-form-item :label="label"
                                      prop="name"
                                      :rules="{ required: true, message: 'Este campo es obligatorio', trigger: 'change' }">
                            <el-input v-my-only-alphanumeric="{maxChars: 10000}" v-model="genericForm.name">
                                <el-button
                                    slot="append"
                                    icon="el-icon-search"
                                    @click.prevent="checkField(genericForm.name)"></el-button>
                            </el-input>
                        </el-form-item>
                    </el-col>
                </el-row>
                <el-row :gutter="20" v-if="catalogId == 2">
                    <el-col :span="12">
                        <el-form-item label="Estado"
                                      prop="cat_state_id"
                                      :rules="{ required: true, message: 'Este campo es obligatorio', trigger: 'change' }">
                            <el-select v-model="genericForm.cat_state_id"
                                       @change="genericForm.cat_municipality_id = null; getMunicipalities(genericForm.cat_state_id)"
                                       style="width: 100%"
                                       placeholder="Seleccione" filterable>
                                <el-option
                                    v-for="item in states"
                                    :key="item.id"
                                    :label="item.name"
                                    :value="item.id">
                                </el-option>
                            </el-select>
                        </el-form-item>
                    </el-col>
                    <el-col :span="12">
                        <el-form-item label="Municipio"
                                      prop="cat_municipality_id"
                                      :rules="{ required: true, message: 'Este campo es obligatorio', trigger: 'change' }">
                            <el-select v-model="genericForm.cat_municipality_id"
                                       v-loading="loading"
                                       style="width: 100%"
                                       placeholder="Seleccione" filterable>
                                <el-option
                                    v-for="item in municipalities"
                                    :key="item.id"
                                    :label="item.name"
                                    :value="item.id">
                                </el-option>
                            </el-select>
                        </el-form-item>
                    </el-col>
                </el-row>
            </el-form>
            <span slot="footer" class="dialog-footer">
                        <el-button
                            type="danger"
                            icon="fas fa-times"
                            @click="addNew=false">
                            Cancelar
                        </el-button>
                        <el-button
                            type="primary"
                            icon="fas fa-save"
                            :disabled="!isFieldValid"
                            @click="saveNewField('genericForm',modelName,genericForm)">
                            Guardar
                        </el-button>
                    </span>
        </el-dialog>

        <!--Add procedure -->
        <el-dialog :title="'Agregar '+ label"
                   :visible.sync="addProcedure"
                   :close-on-press-escape="false"
                   :close-on-click-modal="false">
            <el-form ref="procedureForm" :model="procedureForm"
                     @submit.native.prevent
                     label-width="120px" label-position="top">
                <el-row :gutter="10">
                    <el-col :span="24">
                        <el-form-item label="Tipo de Trámite"
                                      prop="cat_category_id"
                                      :rules="{ required: true, message: 'Este campo es obligatorio', trigger: 'change' }">
                            <el-select v-model="procedureForm.cat_category_id"
                                       style="width: 100%"
                                       placeholder="Seleccione" filterable>
                                <el-option
                                    v-for="item in categories"
                                    :key="item.id"
                                    :label="item.name"
                                    :value="item.id">
                                </el-option>
                            </el-select>
                        </el-form-item>
                    </el-col>
                </el-row>
                <el-row :gutter="10">
                    <el-col :span="24">
                        <el-form-item :label="label"
                                      prop="name"
                                      :rules="{ required: true, message: 'Este campo es obligatorio', trigger: 'change' }">
                            <el-input v-my-only-alphanumeric v-model="procedureForm.name">
                                <el-button
                                    slot="append"
                                    icon="el-icon-search"
                                    @click.prevent="checkField2(procedureForm,'procedureForm')"></el-button>
                            </el-input>
                        </el-form-item>
                    </el-col>
                </el-row>
            </el-form>
            <span slot="footer" class="dialog-footer">
                        <el-button
                            type="danger"
                            icon="fas fa-times"
                            @click="addProcedure=false">
                            Cancelar
                        </el-button>
                        <el-button
                            type="primary"
                            icon="fas fa-save"
                            :disabled="!isFieldValid"
                            @click="saveNewField('procedureForm',modelName,procedureForm)">
                            Guardar
                        </el-button>
                    </span>
        </el-dialog>


    </div>
</template>

<script>
    import CatsActions from './partials/CatsActions';


    export default {
        components: {
            CatsActions
        },
        computed: {

            alias_this() {
                return this;
            },


        },
        data() {
            return {
                heightTable: '450',
                catalogs: [],
                dynamicCats: [],
                showTable: false,
                showGeneric: false,
                addNew: false,
                isFieldValid: false,
                loading: false,
                loadingCats: false,
                addNewNeighborhood: false,
                addNewLocality: false,
                addNewState: false,
                addNewPostal: false,
                addProcedure: false,
                procedureForm: {
                    name: '',
                    cat_category_id: ''
                },
                countryId: '',
                stateId: '',
                localityId: '',
                neighborhoodId: '',
                currentPage: 1,
                perPage: 50,
                total: 0,
                type: '',
                register: {},
                genericForm: {
                    name: '',
                    cat_state_id: '',
                    cat_municipality_id: ''
                },
                search: '',
                modelName: '',
                label: '',
                catalogId: '',
                icon: 'el-icon-search',
                countries: [],
                states: [],
                localities: [],
                neighborhoods: [],
                neighborhoodForm: {
                    name: '',
                    locality_id: '',
                    state_id: '',
                    country_id: ''

                },
                localityForm: {
                    name: '',
                    geo_cat_state_id: '',
                    geo_cat_country_id: ''
                },
                stateForm: {
                    name: '',
                    geo_cat_country_id: ''
                },
                postalForm: {
                    code: '',
                    country_id: '',
                    state_id: '',
                    locality_id: '',
                    neighborhood_id: ''

                },
                categories: [],
                municipalities: []

            }
        },

        created() {
            axios.get('/api/admin-cats').then(response => {
                this.catalogs = _.orderBy(response.data.catalogs, ['name'], ['asc']);
                setTimeout(() => {
                    let _location = window.location.search;
                    if (_location == '?showProcedure=true') {
                        this.catalogId = 5;
                        this.getCatalog(this.catalogId, 1);
                    }
                }, 600)

            }).catch(error => {
                let msg = 'Error al cargar información.';
                this.$store.dispatch('notifications/error', {msg: msg}, {root: true});
            });
            window.addEventListener('resize', this.handleResize);
            this.handleResize();
        },
        destroyed() {
            window.removeEventListener('resize', this.handleResize)
        },
        mounted() {
            this.handleResize();
        },
        methods: {
            handleResize() {
                this.heightTable = window.innerHeight * 2;
            },
            showLoading() {
                this.$store.dispatch(
                    'loading/spinner',
                    {msg: 'Cargando Datos...', status: true},
                    {root: true}
                );
            },
            hideLoading() {
                this.$store.dispatch('loading/spinner', {}, {root: true});
            },

            changeEditable(row, column, cell, event) {
                if (column && (column.property == 'name' || column.property == 'order')) {
                    return row.editable = true
                }
            },

            getCatalog(id, type) {
                this.type = null;
                this.showGeneric = null;
                if (type == 1) {
                    this.currentPage = 1;
                    this.search = '';
                }
                this.$store.dispatch(
                    'loading/spinner', {msg: 'Cargando Datos...', status: true}, {root: true});
                if (id != '') {
                    let params = {
                        catalog: id,
                        search: this.search,
                        page: this.currentPage,
                        perPage: this.perPage,
                    };


                    axios.get('/api/admin-cats/create', {params}).then(response => {
                        if (response.data.success) {
                            let _response = response.data;
                            this.dynamicCats = _response.dynamicCats.catalog.data;
                            this.total = _response.dynamicCats.catalog.total;
                            this.label = _response.dynamicCats.label;
                            this.catalogId = _response.dynamicCats.id;
                            this.modelName = _response.dynamicCats.model;
                            this.type = _response.dynamicCats.type;
                            this.categories = _response.dynamicCats.categories;
                            this.states = _response.dynamicCats.states;
                            if (this.type == 1) {
                                this.showGeneric = true;
                            }
                            this.$store.dispatch('loading/spinner', {}, {root: true});
                        } else {
                            this.closeTable();
                            this.$store.dispatch('notifications/error',
                                {msg: 'No fue posible mostrar información de catálogo o no cuenta con autorización.'},
                                {root: true});
                            this.$store.dispatch('loading/spinner', {}, {root: true});
                        }

                    }).catch(error => {
                        console.log('error', error);
                        this.$store.dispatch('notifications/error',
                            {msg: 'No fue posible mostrar información de catálogo o no cuenta con autorización.'},
                            {root: true});
                        this.$store.dispatch('loading/spinner', {}, {root: true});
                    });
                } else {
                    this.$store.dispatch('loading/spinner', {}, {root: true});
                    this.label = '';
                    this.showTable = false;
                }
            },

            filterOrder(order) {
                if (!order) return '';
                if (order) {
                    let _order = order;
                    if (_order <= 0) {
                        this.$notify.warning({
                            title: 'Atención',
                            message: 'El orden no puede ser menor o igual a cero'
                        });
                        order = ''
                    }
                    return order;
                }
            },

            handleCurrentChange(page) {
                this.currentPage = page;
                this.getCatalog(this.catalogId);
            },

            showDialog() {
                if(this.catalogId == 2){
                    this.genericForm.cat_state_id = '';
                    this.genericForm.cat_municipality_id = '';
                }
                if (this.showGeneric) {
                    this.addNew = true;
                    this.genericForm.name = '';
                    this.isFieldValid = false;
                } else if (this.type == 2) {
                    if (this.catalogId == 5) {
                        this.addProcedure = true;
                        this.procedureForm.name = '';
                        this.procedureForm.cat_category_id = '';
                        this.isFieldValid = false;
                    }
                }
            },

            closeTable() {
                this.showGeneric = false;
                this.catalogId = null;
                this.label = '';
            },

            checkField(field) {
                if (field != '') {
                    axios.post('/api/admin-cats/check-field', {
                        field: field,
                        catalog: this.catalogId,
                        form: this.genericForm
                    }).then(response => {
                        this.$store.dispatch('notifications/ok', {msg: response.data.message}, {root: true});
                        this.isFieldValid = true;

                    }).catch(error => {
                        this.$store.dispatch('notifications/error', {msg: 'El campo que ingresó ya existe en el catálogo, favor de verificar.'}, {root: true});
                        this.isFieldValid = false;

                    });
                } else {
                    this.$store.dispatch('notifications/error', {msg: 'Completar los campos requeridos.'}, {root: true});

                }

            },

            checkField2(field, ref) {
                this.$refs[ref].validate((valid) => {
                    if (valid) {
                        let _url = null;
                        if (ref == 'procedureForm') {
                            _url = '/api/admin-cats/check-procedure'
                        }

                        if (_url) {
                            axios.post(_url, {
                                form: field,
                                catalog: this.catalogId
                            }).then(response => {
                                if (response.data.success) {
                                    this.$store.dispatch('notifications/ok', {msg: response.data.message}, {root: true});
                                    this.isFieldValid = true;
                                } else {
                                    this.$store.dispatch('notifications/error', {msg: response.data.message}, {root: true});
                                    this.isFieldValid = false;
                                }

                            }).catch(error => {
                                this.$store.dispatch('notifications/error',
                                    {msg: 'No se pudo completar acción'}
                                    , {root: true});
                                this.isFieldValid = false;

                            });
                        }
                    } else {
                        this.$store.dispatch('loading/spinner', {}, {root: true});
                        this.$store.dispatch('notifications/warning',
                            {msg: 'Por favor complete todos los campos requeridos'},
                            {root: true});
                        return false;
                    }
                });
            },

            saveNewField(ref, catalog, form) {
                this.$refs[ref].validate((valid) => {
                    if (valid) {
                        let data = {
                            catalog: catalog,
                            form: form,
                        };
                        axios.post('/api/admin-cats', data).then(response => {
                            let _response = response.data.success;

                            if (_response) {
                                this.getCatalog(this.catalogId);
                                this.addNew = false;
                                this.addProcedure = false;
                                this.$store.dispatch('notifications/ok',
                                    {msg: 'Se agregó un nuevo campo en catálogo'},
                                    {root: true});

                            } else {
                                this.$store.dispatch('notifications/error',
                                    {msg: 'Error al agregar, verifique que no esté duplicado el valor'},
                                    {root: true});
                            }

                        }).catch(error => {

                            this.$store.dispatch('notifications/error',
                                {msg: 'No fue posible agregar rubro'},
                                {root: true});
                        });
                    } else {
                        this.$store.dispatch('loading/spinner', {}, {root: true});
                        this.$store.dispatch('notifications/warning',
                            {msg: 'Por favor complete todos los campos requeridos'},
                            {root: true});
                        return false;
                    }
                });
            },

            filterStates(countryId) {
                if (!countryId) return this.states = [];
                if (countryId) {
                    this.loadingCats = true;
                    this.neighborhoodForm.state_id = null;
                    axios.get('/api/get-states', {params: {country_id: countryId}}).then(response => {
                        if (response.data.success) {
                            this.states = response.data.states;
                            this.loadingCats = false;
                        } else {
                            this.$notify.error({
                                title: 'Error',
                                message: 'Error al cargar estados'
                            })
                        }
                    }).catch(error => {

                        this.$store.dispatch('notifications/error',
                            {msg: 'No fue posible agregar rubro'},
                            {root: true});
                    });
                }
            },

            filterLocalities(stateId) {
                if (!stateId) return this.localities = [];

                if (stateId) {
                    this.loadingCats = true;
                    this.neighborhoodForm.locality_id = null;
                    axios.get('/api/get-localities', {params: {state_id: stateId}}).then(response => {
                        if (response.data.success) {
                            this.localities = response.data.localities;
                            this.loadingCats = false;
                        } else {
                            this.$notify.error({
                                title: 'Error',
                                message: 'Error al cargar estados'
                            })
                        }
                    }).catch(error => {

                        this.$store.dispatch('notifications/error',
                            {msg: 'No fue posible agregar rubro'},
                            {root: true});
                    });
                }

            },

            filterNeighborhood(localityId) {
                if (!localityId) return this.neighborhoods = [];

                if (localityId) {
                    this.loadingCats = true;
                    this.postalForm.neighborhood_id = null;
                    axios.get('/api/get-neighborhoods', {params: {locality_id: localityId}}).then(response => {
                        if (response.data.success) {
                            this.neighborhoods = response.data.neighborhoods;
                            this.loadingCats = false;
                        } else {
                            this.$notify.error({
                                title: 'Error',
                                message: 'Error al cargar estados'
                            })
                        }
                    }).catch(error => {

                        this.$store.dispatch('notifications/error',
                            {msg: 'No fue posible agregar rubro'},
                            {root: true});
                    });
                }
            },

            specificFilter(countryId, stateId, localityId, type) {
                if (countryId || stateId || localityId) {
                    let params = {
                        countryId: countryId,
                        stateId: stateId,
                        localityId: localityId,
                        type: type
                    };
                    axios.post('/api/specific-filter', params).then(response => {
                        if (response.data.success) {
                            this.dynamicCats = response.data.catalog.data;
                            this.total = response.data.catalog.total
                        }

                    }).catch(error => {

                        this.$store.dispatch('notifications/error',
                            {msg: 'No fue posible agregar rubro'},
                            {root: true});
                    });
                    ;
                }
            },

            closeWindow() {
                setTimeout(() => {
                    window.close();
                }, 500);
            },

            getMunicipalities(state) {
                if (state) {
                    this.loading = true;
                    let params = {
                        cat_state_id: state
                    };
                    axios.get('/api/service-town', {params}).then(response => {
                        if (response.data.success) {
                            this.municipalities = response.data.municipalities;
                            this.loading = false;
                        } else {
                            this.loading = false;
                            this.$notify.error({
                                title: 'Error',
                                message: 'Error al cargar Municipios'
                            })
                        }
                    }).catch(error => {
                        this.loading = false;
                        this.$store.dispatch('notifications/error',
                            {msg: 'No fue posible agregar rubro'},
                            {root: true});
                    });
                }

            },

            customNotary(data, index) {
                if (data && data.cat_state_id) {
                    _.forEach(this.dynamicCats, (item, key) => {
                        if (key != index) {
                            item.editable = false;
                        }
                    });
                    data.editable = true;
                    this.getMunicipalities(data.cat_state_id);
                }
            }
        }
    }
</script>

<style scoped>
    .buttonFixed {

        outline: none;
        position: fixed;
        z-index: 99;
        bottom: 0.5em;
        right: 5.5em;
        /*top: 50.0em;*/
        border-radius: 30px;
        font-size: 15px;
        padding: 10px 15px 10px 15px;
        border-radius: 45px;
        background-color: #880000;
        background-image: radial-gradient(circle farthest-corner at 100% 0, #c6153c, transparent);
        border: 1px solid #dcdfe6;
        color: #fff;
    }

    .buttonFixed:hover {
        cursor: pointer;
        background-color: #880000;
        background-image: radial-gradient(circle farthest-corner at 100% 0, #c6153c, transparent);
    }

    .buttonFixed:active,
    .buttonFixed:visited,
    .buttonFixed:link {
        background-color: #333333;
        background-image: radial-gradient(circle farthest-corner at 100% 0, #c6153c, transparent);
    }
</style>
